<template>
  <bk-page class="paySuccessPage" pageType="navPage" :navBarInfo="navBarInfo" @close="toReservePage">
		<bk-view class="success-body" v-if="formData.id">
      <bk-view class="view-baseInfo">
        <bk-view class="view-status-main">
          <template v-if="['MASE_APP_STAFF','MASE_APP_MANAGE','MASE_MANAGEMENT'].includes(formData.source) || systemInfo['MASE020']">
            <bk-image :src="$bk_getImageUrl('Def_Icon_Success.png')"></bk-image>
            <bk-lang class="view-name" code="res_success_appointment"></bk-lang>
          </template>
          <template v-else>
            <bk-image :src="$bk_getImageUrl('Def_Icon_AppointmentTobeConfirmed.png')"></bk-image>
            <bk-lang class="view-name" code="res_success_appointment_confirmed"></bk-lang>
          </template>
        </bk-view>
        <bk-view class="view-date-main">
          <bk-date :date="formData.reserveDate" :curShop="curShop" showHm showWeek></bk-date>
          <span v-if="!['jp'].includes(languageType)">&nbsp;&nbsp;{{ resDateTxt }}</span>
        </bk-view>
        <!-- <bk-view class="view-pay-main" v-if="reserveCharge?.chargeForm===1">
					<bk-view class="view-image"></bk-view>
          <div class="view-text">{{ paymentWillText }}</div>
        </bk-view> -->
      </bk-view>
			<bk-button @click="toReservePage" langCode="res_success_got_it"></bk-button>
		</bk-view>
	</bk-page>
</template>

<script>

	import dayjs from 'dayjs';
	import { reserveReq, baseReq, shopReq } from '@/reqService';

	export default {
		name:'paySuccess',
		data (){
			return {
				languageType: this.$bk_getLanguageType(),
				formData:{},
				navBarInfo:{
					backFlag: true, 
				},
				curShop:{},
				systemInfo:{}
			};
		},
		computed:{
			resDateTxt () {
				return `${this.$bk_lang['date_week_'+dayjs(this.formData?.reserveDate).day()]}`;
			},
			paymentWillText (){
				let val = `${this.curShop?.currencySymbol || ''} ${this.formData?.depositAmount || 0}`;
				return this.$bk_replaceVAR('paySuccess_paymentWill', val);
			},
			reserveCharge (){
				let { reserveCharge={} } = this.formData;
				return reserveCharge;
			},
			maSeReservePaymentItem (){
				return this.formData?.maSeReservePaymentList[0] || {};
			}
		},
		mounted (){
			let token = this.$bk_getAccessToken();

			if (this.$bk_isNull(token)) {
				let that = this;
				window.viewCallback = function () {
					that.initData();
				};
				return;
			}
			this.initData();
		},
		
		methods:{
			async initData (){
				const { reserveId } = this.$route.query;
				
				if(!reserveId){
					return false;
				}
			
				let res = await reserveReq.requestGetResDetailById(this, reserveId);
				res.reserveDate = res.startDateTime?.showValue;
				
				let params = {
					compId:res.compId, 
					custId:res.custId,
					paramCodes:[
						'MASE020', // 自动接受预约
					],
				};
				const resSystemInfo = await baseReq.requestGetSystemParamsByCodes(this, params);
				const curShop = await shopReq.requestGetShopDetailByCompId(this, params.compId);

				this.curShop = curShop;
				this.systemInfo = resSystemInfo.systemInfo;
				this.formData = res;
			},
			toReservePage (){
				let ShopDetailId = localStorage.getItem('ShopDetailId');
				const { compId, custId } = this.formData;

				if(ShopDetailId){
					this.$router.replace(`/shopDetail?compId=${compId}&custId=${custId}`);
				}else {
					this.$router.replace('/home');
					this.$nextTick(() => {
						window.showReserve({ resShopInfo:{ id:compId} });
					});
				}
			}
		}
	};
</script>

<style lang="less">
@import './paySuccess.less';
</style>